"use client";
import * as stylex from "@stylexjs/stylex";
import * as React from "react";
import { useBlock } from "timvir/core";
import { layoutStyles } from "../../core/layout";
import { cx } from "../../internal/cx";
/**
 * The underlying DOM element which is rendered by this component.
 */ const Root = "div";
export function Swatch(props) {
    const block = useBlock(props);
    const { value, contrastValue, name, ancestry, onClick, onMouseLeave, className, style, ...rest } = block.props;
    const [label, setLabel] = React.useState(name);
    React.useEffect(()=>{
        setLabel(name);
    }, [
        name
    ]);
    const rootStyleProps = stylex.props(layoutStyles.block, styles.root);
    const innerStyleProps = {
        className: "x78zum5 xdt5ytf xl56j7k x10l6tqk x13vifvy x3m8u43 x1ey2m1c xu96u03 xzhuw26 x84vhe8 x1ypdohk x1cum3z5"
    };
    return <Root role="button" {...rest} {...rootStyleProps} className={cx(rootStyleProps.className, className)} style={{
        ...style,
        ...rootStyleProps.style,
        height: ancestry ? 48 : 36
    }} onClick={(ev)=>{
        navigator.clipboard.writeText(value);
        setLabel("Copied to clipboard");
        onClick?.(ev);
    }} onMouseLeave={(ev)=>{
        setLabel(name);
        onMouseLeave?.(ev);
    }}>
      <div {...innerStyleProps} style={{
        ...innerStyleProps.style,
        background: value,
        color: contrastValue
    }}>
        <div className="x78zum5 x1qughib x6s0dn4 xo5v014">
          {label && <div>{label}</div>}
          {label === name && <div>{value}</div>}
        </div>
        {ancestry && <div className="x1yrsyyn xbyyjgo xsfzzmd xo5v014">{ancestry}</div>}
      </div>
    </Root>;
}
const styles = {
    root: {
        kVAEAm: "x1n2onr6",
        $$css: true
    }
};
